<template>
  <div class="space-y-6 mt-[32px]">
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 print:grid-cols-1">
      <div class="lg:col-span-2">
        <ChartCard
          :title="comparison?.title || 'Media por empresas'"
          :subtitle="comparison?.subtitle || 'visão geral das empresas'"
        >
          <BarYesNoChart
            :data="comparisonData"
            :variant="comparison?.variant || 'binary_stacked'"
            :horizontal="shouldUseHorizontal"
          />
        </ChartCard>
      </div>

      <div>
        <ChartCard
          :title="overviewPanel?.title || 'Total Geral'"
          :subtitle="overviewPanel?.subtitle || 'Resumo geral'"
        >
          <div
            class="h-80 print:justify-items-center print:justify-center print:text-black"
          >
            <DonutYesNoChart
              :segments="overviewPanel?.segments || []"
              :variant="overviewPanel?.variant || 'binary_donut'"
              :summary="overviewPanel?.summary || {}"
            />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="print:hidden">
      <ChartCard
        :title="monthlyPerformance?.title || 'Performance Mensal'"
        :subtitle="monthlyPerformance?.subtitle || 'Setores e Empresas'"
      >
        <div class="h-80">
          <LinePerformanceChart
            :categories="monthlyPerformance?.categories || []"
            :series-data="monthlyPerformance?.series || []"
            :variant="monthlyPerformance?.variant || 'binary_lines'"
          />
        </div>
      </ChartCard>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import ChartCard from "@/components/admin/ChartCard.vue";
import BarYesNoChart from "./charts/BarYesNoChart.vue";
import DonutYesNoChart from "./charts/DonutYesNoChart.vue";
import LinePerformanceChart from "./charts/LinePerformanceChart.vue";

const props = defineProps({
  responseMode: {
    type: String,
    default: "binary",
  },
  comparison: {
    type: Object,
    default: () => ({
      title: "",
      subtitle: "",
      variant: "binary_stacked",
      items: [],
    }),
  },
  overviewPanel: {
    type: Object,
    default: () => ({
      title: "",
      subtitle: "",
      variant: "binary_donut",
      summary: {},
      segments: [],
    }),
  },
  monthlyPerformance: {
    type: Object,
    default: () => ({
      title: "",
      subtitle: "",
      variant: "binary_lines",
      categories: [],
      series: [],
    }),
  },
});

const isMobile = computed(() => window.innerWidth < 768);
const comparisonData = computed(() => props.comparison?.items || []);
const shouldUseHorizontal = computed(() => {
  return comparisonData.value.length > 10 || isMobile.value;
});
</script>
